'use strict';

var EditRouter = require('actionGroups/router/Router');

module.exports = {
  Model: EditRouter,
};
